import "./SideMenu.scss";

import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../app/hooks";
import { ReactComponent as AcedImg } from "../../assets/images/Aced.svg";
import { ReactComponent as Logout } from "../../assets/images/logout-3.svg";
import { logoutAction, selectUser } from "../../core/auth/authSlice";
import { useComponentVisible } from "../../shared/customHooks";
import { User } from "../../shared/models";
import http from "../../shared/utils/http";
import { getProfilePictureUrl } from "../../shared/utils/profilePictureUrl";
import { capitalizeName } from "../../shared/utils/util";
import Button from "../essentials/button/Button";
import ClickIcon from "../essentials/icon-buttons/click-icon/ClickIcon";
import LanguageSelector from "../language-selector/LanguageSelector";
import TeamList from "./team-list/TeamList";

import userPlaceholder from "../../assets/images/userPlaceholder.png";
import SubscribeButton from "./SubscribeButton";

const SideMenu: React.FC = () => {
	const { actorId, avatarVersion, userId, profilePictureUrl } = useSelector(selectUser) as User;
	const { t } = useTranslation();
	//   const { name, lastName, profileBadge } = useSelector(
	//     (state: any) => state.Reducer
	//   );
	//   const dispatch = useDispatch();
	const navigate = useNavigate();
	const dispatch = useAppDispatch();
	const { ref, isComponentVisible, setIsComponentVisible } =
		useComponentVisible(false);
	const user = useSelector(selectUser);
	const disabledFunction = !user?.profileCompleted;

	const { name, surname, sport } = useSelector(selectUser) as User;

	const [isTeamListVisible, setTeamListVisible] = useState<boolean>(false);
	const [hasTeam, setHasTeam] = useState<boolean>(false);

	// Check if user has a team
	useEffect(() => {
		if (userId) {
			http
				.get(`/teams/${userId}/teams`)
				.then((res) => {
					// User has a team if response contains a valid team with id
					setHasTeam(res && res.id);
				})
				.catch(() => {
					setHasTeam(false);
				});
		}
	}, [userId]);

	const toggleTeamList = () => {
		setTeamListVisible(!isTeamListVisible);
	};

	return (
		<>
			<div ref={ref}>
				{/* <Can I="read" a="Member" this={{active: false}}>
          <div>Contenuto accessibile</div>
        </Can>*/}
				<div className="header-button__profile-picture">
					<img
						src={getProfilePictureUrl(actorId, avatarVersion, profilePictureUrl) || userPlaceholder}
						alt="profile"
						className="header-button__profile-picture-image"
						onClick={() => setIsComponentVisible(true)}
						onError={(e) => (e.currentTarget.src = userPlaceholder)}
					/>
				</div>
				<div className={isComponentVisible ? "side-menu open" : "side-menu"}>
					<div>
						<div className="side-menu__header">
							<div className="side-menu__header-user-card">
								<img
									src={getProfilePictureUrl(actorId, avatarVersion, profilePictureUrl) || userPlaceholder}
									alt="profile"
									className="header-button__profile-picture-image"
									style={{ cursor: "default" }}
									onError={(e) => (e.currentTarget.src = userPlaceholder)}
								/>

								<div className="side-menu__header-captions">
									<Button
										className="btn btn-link side-menu__header-captions-title"
										action={() => {
											navigate(`/u/${actorId}`);
											setIsComponentVisible(false);
										}}
									>
										{capitalizeName(name)} {capitalizeName(surname)}
									</Button>
									<p className="side-menu__header-captions-subtitle">
										{sport && t("sportData.sportsLabels." + sport)}
									</p>
								</div>
							</div>
							<div
								className="down-arrow-barrel"
								style={{
									transform: isTeamListVisible
										? "rotate(180deg)"
										: "rotate(0deg)",
								}}
							>
								<ClickIcon
									icon="downarrow"
									color="black"
									onClick={toggleTeamList}
								/>
							</div>
							<div
								className={`side-menu__header-team-list ${
									isTeamListVisible && "side-menu__header-team-list-open"
								}`}
							>
								<TeamList setSideMenuVisible={setIsComponentVisible} />
							</div>
						</div>

						<div className="side-menu__divider"></div>

						<div className="side-menu__navigation">
							{!disabledFunction && (
								<>
									<Button
										className="btn btn-link side-menu__navigation-btn"
										action={() => navigate("/team/create")}
										disabled={hasTeam}
									>
										{t("sideMenu.createTeamPage")}
									</Button>
									<Button
										className="btn btn-link side-menu__navigation-btn"
										action={() => {
											navigate("/settings");
											setIsComponentVisible(false);
										}}
									>
										{t("sideMenu.settings")}
									</Button>
									<Button
										className="btn btn-link side-menu__navigation-btn"
										disabled
									>
										{t("sideMenu.notifications")}
									</Button>
									{/* <Button className="btn btn-link side-menu__navigation-btn side-menu__navigation-btn-premium"></Button> */}
									<SubscribeButton
										onNavigate={() => setIsComponentVisible(false)}
									/>
								</>
							)}
						</div>
					</div>

					<div className="side-menu__footer">
						<LanguageSelector />
						<Button
							className="btn btn-link side-menu__navigation-btn "
							action={() => {
								dispatch(logoutAction());
								setIsComponentVisible(false);
							}}
						>
							{<Logout className="side-menu__navigation-btn-icon" />}
							{t("common.buttons.logout")}
						</Button>

						<div className="side-menu__footer-banner">
							<AcedImg />
							<br />
							<p className="side-menu__footer-banner-p">
								{t("sideMenu.footer.developmentWarning")}
							</p>
							<p className="side-menu__footer-banner-p">
								{t("sideMenu.footer.copyright")}
							</p>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default SideMenu;
